// import ProductCard, { ProductCardProps } from './ProductCard';
import { ProductCard, ProductCardProps } from './product-card.component'

export default ProductCard

export { type ProductCardProps, ProductCard }
